export const VALIDATION_STATE_PASSED = "passed";
export const VALIDATION_STATE_FAILED = "failed";
export const VALIDATION_STATE_NOT_APPLICABLE = "not_applicable";

const VALIDATION_STATES = new Set([
  VALIDATION_STATE_PASSED,
  VALIDATION_STATE_FAILED,
  VALIDATION_STATE_NOT_APPLICABLE,
]);

export function getValidationState(logData) {
  if (VALIDATION_STATES.has(logData?.state)) {
    return logData.state;
  }

  if (logData?.ok === true) return VALIDATION_STATE_PASSED;
  if (logData?.ok === false) return VALIDATION_STATE_FAILED;

  return null;
}

export function getValidationEntries(log, { includeNotApplicable = true } = {}) {
  if (!log || typeof log !== "object" || Array.isArray(log)) return [];

  const entries = Object.entries(log).map(([key, data]) => {
    const normalizedData = data && typeof data === "object" ? data : {};
    const resolvedState = getValidationState(normalizedData);

    return {
      key,
      data: normalizedData,
      // Unknown entries must never be shown as successful checks.
      state: resolvedState || VALIDATION_STATE_FAILED,
      hasUnknownState: resolvedState === null,
    };
  });

  const applicable = entries.filter(({ state }) => state !== VALIDATION_STATE_NOT_APPLICABLE);

  if (!includeNotApplicable) return applicable;

  const notApplicable = entries.filter(({ state }) => state === VALIDATION_STATE_NOT_APPLICABLE);

  return [...applicable, ...notApplicable];
}
